import {ReactNode} from 'react'
import cn from 'clsx'

import './ListHeader.scss'

interface ListHeaderProps {
  className?: string
  children: ReactNode
}

export default function ListHeader({className, children}: ListHeaderProps) {
  return <div className={cn('ListHeader', className)}>{children}</div>
}
